export const MAIN_AGENCY_ID = "78090e23-d49a-4eb8-80fc-16581c535b9e";
export const CREATOR_X_CHANGE_AGENCY_ID = "8f84c769-88a1-48a0-bf17-e674bc238d41";

// Meta App Review test account. We hide internal sections (Artists, Brands,
// X Trending) from this login so reviewers only see the Instagram messaging
// flow they're reviewing. Remove after App Review approval.
export const META_REVIEW_EMAIL = "metareview@wvemedia.com";

export function isMetaReviewEmail(email?: string | null): boolean {
  return !!email && email.toLowerCase() === META_REVIEW_EMAIL;
}

// Restrict the System Status page to WVE (main) agency users. Remove this gate
// (page, sidebar link, and the matching server-side check in
// controllers/systemStatus.ts) to reopen it to all logged-in users.
export function canViewStatusPage(agencyId?: string | null): boolean {
  return agencyId === MAIN_AGENCY_ID;
}

// Map of agencies to additional agencies they are allowed to view
export const CROSS_AGENCY_VIEWS: Record<string, string[]> = {
  [MAIN_AGENCY_ID]: [CREATOR_X_CHANGE_AGENCY_ID],
};

export function getAccessibleAgencyIds(agencyId?: string | null): string[] {
  if (!agencyId) return [];
  const extra = CROSS_AGENCY_VIEWS[agencyId] || [];
  return [agencyId, ...extra];
}

export function isMirroredCampaign(userAgencyId: string, campaignAgencyId: string): boolean {
  if (userAgencyId === campaignAgencyId) return false;
  const accessible = getAccessibleAgencyIds(userAgencyId);
  return accessible.includes(campaignAgencyId);
}

/** Flip to true to show the Ask AI floating assistant. */
export const CAMPAIGN_ASSISTANT_UI_ENABLED = false;

export function isCampaignAssistantEnabled(agencyId?: string | null): boolean {
  return agencyId === MAIN_AGENCY_ID;
} 